import * as COMPONENT from '@Components';
import Data from './data';

export default function Component() {
  return (
    <div className="container mt-5 team">
      <div className="row">
        <div className="col text-center mb-md-5 mb-4">
          <h3 className="fw-bolder">Meet the Team</h3>
        </div>
      </div>
      <div className="row gap-lg-5 justify-content-center">
        {Data.map((member, id) => (
          <COMPONENT.AboutMember
            image={member.image}
            name={member.name}
            position={member.position}
            address={member.address}
            desc={member.desc}
            linkedin={member.linkedin}
            github={member.github}
            instagram={member.instagram}
            key={id}
          />
        ))}
      </div>
    </div>
  );
};
